module.exports = __webpack_public_path__ + "img/btn.4bae0dbe.svg";